// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/event.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { Principal } from "./identity_pb";
import { file_gitpod_v1_identity } from "./identity_pb";
import type { PaginationRequest, PaginationResponse, Sort } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/event.proto.
 */
export const file_gitpod_v1_event: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_identity, file_gitpod_v1_pagination, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.WatchEventsRequest
 */
export type WatchEventsRequest = Message<"gitpod.v1.WatchEventsRequest"> & {
  /**
   * Scope defines the kind of events one watches. If no value is provided we default to organization scope.
   *
   * @generated from oneof gitpod.v1.WatchEventsRequest.scope
   */
  scope: {
    /**
     * Organization scope produces events for all projects, runners and environments
     * the caller can see within their organization. No task, task execution or service events
     * are produed.
     *
     * @generated from field: bool organization = 1;
     */
    value: boolean;
    case: "organization";
  } | {
    /**
     * Environment scope produces events for the environment itself, all tasks, task executions,
     * and services associated with that environment.
     *
     * @generated from field: string environment_id = 2;
     */
    value: string;
    case: "environmentId";
  } | { case: undefined; value?: undefined };

  /**
   * Filters to limit which events are delivered on organization-scoped streams.
   * When empty, all events for the scope are delivered.
   * When populated, only events matching at least one filter entry are forwarded.
   * Not supported for environment-scoped streams; setting this field returns an error.
   *
   * @generated from field: repeated gitpod.v1.WatchEventsRequest.ResourceTypeFilter resource_type_filters = 3;
   */
  resourceTypeFilters: WatchEventsRequest_ResourceTypeFilter[];
};

/**
 * Describes the message gitpod.v1.WatchEventsRequest.
 * Use `create(WatchEventsRequestSchema)` to create a new message.
 */
export const WatchEventsRequestSchema: GenMessage<WatchEventsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_event, 0);

/**
 * ResourceTypeFilter restricts which events are delivered for a specific resource type.
 *
 * @generated from message gitpod.v1.WatchEventsRequest.ResourceTypeFilter
 */
export type WatchEventsRequest_ResourceTypeFilter = Message<"gitpod.v1.WatchEventsRequest.ResourceTypeFilter"> & {
  /**
   * The resource type to filter for.
   *
   * @generated from field: gitpod.v1.ResourceType resource_type = 1;
   */
  resourceType: ResourceType;

  /**
   * If non-empty, only events for these specific resource IDs are delivered.
   *
   * @generated from field: repeated string resource_ids = 2;
   */
  resourceIds: string[];

  /**
   * If non-empty, only events where the resource was created by one of these user IDs
   * are delivered. Skipped for DELETE operations (creator info is unavailable after deletion).
   * Events with no creator information are skipped when this filter is set (fail-closed).
   *
   * @generated from field: repeated string creator_ids = 3;
   */
  creatorIds: string[];
};

/**
 * Describes the message gitpod.v1.WatchEventsRequest.ResourceTypeFilter.
 * Use `create(WatchEventsRequest_ResourceTypeFilterSchema)` to create a new message.
 */
export const WatchEventsRequest_ResourceTypeFilterSchema: GenMessage<WatchEventsRequest_ResourceTypeFilter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_event, 0, 0);

/**
 * @generated from message gitpod.v1.WatchEventsResponse
 */
export type WatchEventsResponse = Message<"gitpod.v1.WatchEventsResponse"> & {
  /**
   * @generated from field: gitpod.v1.ResourceOperation operation = 1;
   */
  operation: ResourceOperation;

  /**
   * @generated from field: gitpod.v1.ResourceType resource_type = 2;
   */
  resourceType: ResourceType;

  /**
   * @generated from field: string resource_id = 3;
   */
  resourceId: string;
};

/**
 * Describes the message gitpod.v1.WatchEventsResponse.
 * Use `create(WatchEventsResponseSchema)` to create a new message.
 */
export const WatchEventsResponseSchema: GenMessage<WatchEventsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_event, 1);

/**
 * @generated from message gitpod.v1.ListAuditLogsRequest
 */
export type ListAuditLogsRequest = Message<"gitpod.v1.ListAuditLogsRequest"> & {
  /**
   * pagination contains the pagination options for listing audit logs
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListAuditLogsRequest.Filter filter = 2;
   */
  filter?: ListAuditLogsRequest_Filter;

  /**
   * sort specifies the order of results. When unspecified, results are sorted
   * by creation time descending (newest first).
   * Supported sort fields: createdAt.
   *
   * @generated from field: gitpod.v1.Sort sort = 3;
   */
  sort?: Sort;
};

/**
 * Describes the message gitpod.v1.ListAuditLogsRequest.
 * Use `create(ListAuditLogsRequestSchema)` to create a new message.
 */
export const ListAuditLogsRequestSchema: GenMessage<ListAuditLogsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_event, 2);

/**
 * @generated from message gitpod.v1.ListAuditLogsRequest.Filter
 */
export type ListAuditLogsRequest_Filter = Message<"gitpod.v1.ListAuditLogsRequest.Filter"> & {
  /**
   * @generated from field: repeated string actor_ids = 1;
   */
  actorIds: string[];

  /**
   * @generated from field: repeated gitpod.v1.Principal actor_principals = 2;
   */
  actorPrincipals: Principal[];

  /**
   * @generated from field: repeated string subject_ids = 3;
   */
  subjectIds: string[];

  /**
   * @generated from field: repeated gitpod.v1.ResourceType subject_types = 4;
   */
  subjectTypes: ResourceType[];

  /**
   * from filters audit logs created at or after this timestamp (inclusive).
   *
   * @generated from field: optional google.protobuf.Timestamp from = 5;
   */
  from?: Timestamp;

  /**
   * to filters audit logs created before this timestamp (exclusive).
   *
   * @generated from field: optional google.protobuf.Timestamp to = 6;
   */
  to?: Timestamp;
};

/**
 * Describes the message gitpod.v1.ListAuditLogsRequest.Filter.
 * Use `create(ListAuditLogsRequest_FilterSchema)` to create a new message.
 */
export const ListAuditLogsRequest_FilterSchema: GenMessage<ListAuditLogsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_event, 2, 0);

/**
 * @generated from message gitpod.v1.ListAuditLogsResponse
 */
export type ListAuditLogsResponse = Message<"gitpod.v1.ListAuditLogsResponse"> & {
  /**
   * @generated from field: repeated gitpod.v1.ListAuditLogsResponse.AuditLogEntry entries = 1;
   */
  entries: ListAuditLogsResponse_AuditLogEntry[];

  /**
   * pagination contains the pagination options for listing environments
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;
};

/**
 * Describes the message gitpod.v1.ListAuditLogsResponse.
 * Use `create(ListAuditLogsResponseSchema)` to create a new message.
 */
export const ListAuditLogsResponseSchema: GenMessage<ListAuditLogsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_event, 3);

/**
 * @generated from message gitpod.v1.ListAuditLogsResponse.AuditLogEntry
 */
export type ListAuditLogsResponse_AuditLogEntry = Message<"gitpod.v1.ListAuditLogsResponse.AuditLogEntry"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string actor_id = 2;
   */
  actorId: string;

  /**
   * @generated from field: gitpod.v1.Principal actor_principal = 3;
   */
  actorPrincipal: Principal;

  /**
   * @generated from field: string subject_id = 4;
   */
  subjectId: string;

  /**
   * @generated from field: gitpod.v1.ResourceType subject_type = 5;
   */
  subjectType: ResourceType;

  /**
   * @generated from field: string action = 6;
   */
  action: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.ListAuditLogsResponse.AuditLogEntry.
 * Use `create(ListAuditLogsResponse_AuditLogEntrySchema)` to create a new message.
 */
export const ListAuditLogsResponse_AuditLogEntrySchema: GenMessage<ListAuditLogsResponse_AuditLogEntry> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_event, 3, 0);

/**
 * @generated from enum gitpod.v1.ResourceOperation
 */
export enum ResourceOperation {
  /**
   * @generated from enum value: RESOURCE_OPERATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESOURCE_OPERATION_CREATE = 1;
   */
  CREATE = 1,

  /**
   * @generated from enum value: RESOURCE_OPERATION_UPDATE = 2;
   */
  UPDATE = 2,

  /**
   * @generated from enum value: RESOURCE_OPERATION_DELETE = 3;
   */
  DELETE = 3,

  /**
   * UPDATE_STATUS is emitted only iff the resource's status has been updated. If the status and something else
   * are updated, a single UPDATE event is emitted.
   *
   * @generated from enum value: RESOURCE_OPERATION_UPDATE_STATUS = 4;
   */
  UPDATE_STATUS = 4,
}

/**
 * Describes the enum gitpod.v1.ResourceOperation.
 */
export const ResourceOperationSchema: GenEnum<ResourceOperation> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_event, 0);

/**
 * @generated from enum gitpod.v1.ResourceType
 */
export enum ResourceType {
  /**
   * @generated from enum value: RESOURCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESOURCE_TYPE_ENVIRONMENT = 1;
   */
  ENVIRONMENT = 1,

  /**
   * @generated from enum value: RESOURCE_TYPE_RUNNER = 2;
   */
  RUNNER = 2,

  /**
   * @generated from enum value: RESOURCE_TYPE_PROJECT = 3;
   */
  PROJECT = 3,

  /**
   * @generated from enum value: RESOURCE_TYPE_TASK = 4;
   */
  TASK = 4,

  /**
   * @generated from enum value: RESOURCE_TYPE_TASK_EXECUTION = 5;
   */
  TASK_EXECUTION = 5,

  /**
   * @generated from enum value: RESOURCE_TYPE_SERVICE = 6;
   */
  SERVICE = 6,

  /**
   * @generated from enum value: RESOURCE_TYPE_ORGANIZATION = 7;
   */
  ORGANIZATION = 7,

  /**
   * @generated from enum value: RESOURCE_TYPE_USER = 8;
   */
  USER = 8,

  /**
   * @generated from enum value: RESOURCE_TYPE_ENVIRONMENT_CLASS = 9;
   */
  ENVIRONMENT_CLASS = 9,

  /**
   * @generated from enum value: RESOURCE_TYPE_RUNNER_SCM_INTEGRATION = 10;
   */
  RUNNER_SCM_INTEGRATION = 10,

  /**
   * @generated from enum value: RESOURCE_TYPE_HOST_AUTHENTICATION_TOKEN = 11;
   */
  HOST_AUTHENTICATION_TOKEN = 11,

  /**
   * @generated from enum value: RESOURCE_TYPE_GROUP = 12;
   */
  GROUP = 12,

  /**
   * @generated from enum value: RESOURCE_TYPE_PERSONAL_ACCESS_TOKEN = 13;
   */
  PERSONAL_ACCESS_TOKEN = 13,

  /**
   * @generated from enum value: RESOURCE_TYPE_USER_PREFERENCE = 14;
   */
  USER_PREFERENCE = 14,

  /**
   * @generated from enum value: RESOURCE_TYPE_SERVICE_ACCOUNT = 15;
   */
  SERVICE_ACCOUNT = 15,

  /**
   * @generated from enum value: RESOURCE_TYPE_SECRET = 16;
   */
  SECRET = 16,

  /**
   * @generated from enum value: RESOURCE_TYPE_SSO_CONFIG = 17;
   */
  SSO_CONFIG = 17,

  /**
   * @generated from enum value: RESOURCE_TYPE_DOMAIN_VERIFICATION = 18;
   */
  DOMAIN_VERIFICATION = 18,

  /**
   * @generated from enum value: RESOURCE_TYPE_AGENT_EXECUTION = 19;
   */
  AGENT_EXECUTION = 19,

  /**
   * @generated from enum value: RESOURCE_TYPE_RUNNER_LLM_INTEGRATION = 20;
   */
  RUNNER_LLM_INTEGRATION = 20,

  /**
   * @generated from enum value: RESOURCE_TYPE_AGENT = 21;
   */
  AGENT = 21,

  /**
   * @generated from enum value: RESOURCE_TYPE_ENVIRONMENT_SESSION = 22;
   */
  ENVIRONMENT_SESSION = 22,

  /**
   * @generated from enum value: RESOURCE_TYPE_USER_SECRET = 23;
   */
  USER_SECRET = 23,

  /**
   * @generated from enum value: RESOURCE_TYPE_ORGANIZATION_POLICY = 24;
   */
  ORGANIZATION_POLICY = 24,

  /**
   * @generated from enum value: RESOURCE_TYPE_ORGANIZATION_SECRET = 25;
   */
  ORGANIZATION_SECRET = 25,

  /**
   * @generated from enum value: RESOURCE_TYPE_PROJECT_ENVIRONMENT_CLASS = 26;
   */
  PROJECT_ENVIRONMENT_CLASS = 26,

  /**
   * @generated from enum value: RESOURCE_TYPE_BILLING = 27;
   */
  BILLING = 27,

  /**
   * @generated from enum value: RESOURCE_TYPE_PROMPT = 28;
   */
  PROMPT = 28,

  /**
   * @generated from enum value: RESOURCE_TYPE_COUPON = 29;
   */
  COUPON = 29,

  /**
   * @generated from enum value: RESOURCE_TYPE_COUPON_REDEMPTION = 30;
   */
  COUPON_REDEMPTION = 30,

  /**
   * @generated from enum value: RESOURCE_TYPE_ACCOUNT = 31;
   */
  ACCOUNT = 31,

  /**
   * @generated from enum value: RESOURCE_TYPE_INTEGRATION = 32;
   */
  INTEGRATION = 32,

  /**
   * @generated from enum value: RESOURCE_TYPE_WORKFLOW = 33;
   */
  WORKFLOW = 33,

  /**
   * @generated from enum value: RESOURCE_TYPE_WORKFLOW_EXECUTION = 34;
   */
  WORKFLOW_EXECUTION = 34,

  /**
   * @generated from enum value: RESOURCE_TYPE_WORKFLOW_EXECUTION_ACTION = 35;
   */
  WORKFLOW_EXECUTION_ACTION = 35,

  /**
   * @generated from enum value: RESOURCE_TYPE_SNAPSHOT = 36;
   */
  SNAPSHOT = 36,

  /**
   * @generated from enum value: RESOURCE_TYPE_PREBUILD = 37;
   */
  PREBUILD = 37,

  /**
   * @generated from enum value: RESOURCE_TYPE_ORGANIZATION_LLM_INTEGRATION = 38;
   */
  ORGANIZATION_LLM_INTEGRATION = 38,

  /**
   * @generated from enum value: RESOURCE_TYPE_CUSTOM_DOMAIN = 39;
   */
  CUSTOM_DOMAIN = 39,

  /**
   * @generated from enum value: RESOURCE_TYPE_ROLE_ASSIGNMENT_CHANGED = 40;
   */
  ROLE_ASSIGNMENT_CHANGED = 40,

  /**
   * @generated from enum value: RESOURCE_TYPE_GROUP_MEMBERSHIP_CHANGED = 41;
   */
  GROUP_MEMBERSHIP_CHANGED = 41,

  /**
   * @generated from enum value: RESOURCE_TYPE_WEBHOOK = 42;
   */
  WEBHOOK = 42,

  /**
   * @generated from enum value: RESOURCE_TYPE_SCIM_CONFIGURATION = 43;
   */
  SCIM_CONFIGURATION = 43,

  /**
   * @generated from enum value: RESOURCE_TYPE_SERVICE_ACCOUNT_SECRET = 44;
   */
  SERVICE_ACCOUNT_SECRET = 44,

  /**
   * @generated from enum value: RESOURCE_TYPE_ANNOUNCEMENT_BANNER = 45;
   */
  ANNOUNCEMENT_BANNER = 45,

  /**
   * @generated from enum value: RESOURCE_TYPE_SERVICE_ACCOUNT_TOKEN = 46;
   */
  SERVICE_ACCOUNT_TOKEN = 46,

  /**
   * @generated from enum value: RESOURCE_TYPE_ROLE_ASSIGNMENT = 47;
   */
  ROLE_ASSIGNMENT = 47,

  /**
   * @generated from enum value: RESOURCE_TYPE_WARM_POOL = 48;
   */
  WARM_POOL = 48,

  /**
   * @generated from enum value: RESOURCE_TYPE_NOTIFICATION = 49;
   */
  NOTIFICATION = 49,
}

/**
 * Describes the enum gitpod.v1.ResourceType.
 */
export const ResourceTypeSchema: GenEnum<ResourceType> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_event, 1);

/**
 * @generated from service gitpod.v1.EventService
 */
export const EventService: GenService<{
  /**
   * Streams events for all projects, runners, environments, tasks, and services based on the
   * specified scope.
   *
   * Use this method to:
   * - Monitor resource changes in real-time
   * - Track system events
   * - Receive notifications
   *
   * The scope parameter determines which events to watch:
   * - Organization scope (default): Watch all organization-wide events including projects,
   *   runners and environments. Task and service events are not included. Use by setting
   *   organization=true or omitting the scope.
   * - Environment scope: Watch events for a specific environment, including its tasks,
   *   task executions, and services. Use by setting environment_id to the UUID of the
   *   environment to watch.
   *
   * @generated from rpc gitpod.v1.EventService.WatchEvents
   */
  watchEvents: {
    methodKind: "server_streaming";
    input: typeof WatchEventsRequestSchema;
    output: typeof WatchEventsResponseSchema;
  },
  /**
   * Lists audit logs with filtering and pagination options.
   *
   * Use this method to:
   * - View audit history
   * - Track user actions
   * - Monitor system changes
   *
   * ### Examples
   *
   * - List all logs:
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - Filter by actor:
   *
   *   ```yaml
   *   filter:
   *     actorIds: ["d2c94c27-3b76-4a42-b88c-95a85e392c68"]
   *     actorPrincipals: ["PRINCIPAL_USER"]
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - Filter by time range:
   *
   *   ```yaml
   *   filter:
   *     from: "2024-01-01T00:00:00Z"
   *     to: "2024-02-01T00:00:00Z"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.EventService.ListAuditLogs
   */
  listAuditLogs: {
    methodKind: "unary";
    input: typeof ListAuditLogsRequestSchema;
    output: typeof ListAuditLogsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_event, 0);

